import styled, {css} from 'styled-components';

import {getColor} from '@yourcoach/shared/styles/utils';

const Container = styled.div<{isScrollable: boolean}>`
  width: 100%;
  min-height: 100%;
  padding-right: 140px;
  padding-left: 140px;
  background-color: ${getColor('lostColors.pageBg')};

  ${p =>
    p.isScrollable &&
    css`
      overflow-y: scroll;
      width: 100vw;
      height: 100vh;
    `}
`;
const Body = styled.main<{isFitted: boolean}>`
  max-width: 1380px;
  margin: 0 auto;

  ${p =>
    p.isFitted &&
    css`
      height: fit-content;
      padding-bottom: 140px;
    `}
`;
const Header = styled.div`
  display: flex;
  padding-top: 40px;
  padding-bottom: 30px;
  justify-content: space-between;
`;

const Content = styled.div`
  min-height: 0;
`;

export const Layout = {
  Body,
  Container,
  Content,
  Header,
};
